import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { color } from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';

const variants = [
  '1r',
  '1b',
  '2r',
  '2b',
  '3',
  3,
  '4',
  4,
  '5',
  5,
  '6',
  6,
  '-1r',
  '-1b',
  '-2r',
  '-2u',
];

const styles = {
  '6': {
    fontSize: 6,
    letterSpacing: '-2.05px',
    lineHeight: '62px',
    fontWeight: 700,
  },
  '5': {
    fontSize: 5,
    letterSpacing: '-1.45px',
    lineHeight: '45px',
    fontWeight: 700,
  },
  '4': {
    fontSize: 4,
    letterSpacing: '-1.15px',
    lineHeight: '38px',
    fontWeight: 700,
  },
  '3': {
    fontSize: 3,
    letterSpacing: '-0.95px',
    lineHeight: '30px',
    fontWeight: 700,
  },
  '2b': {
    fontSize: 2,
    letterSpacing: '-0.75px',
    lineHeight: '26px',
    fontWeight: 700,
  },
  '2r': {
    fontSize: 2,
    letterSpacing: '-0.7px',
    lineHeight: '30px',
    fontWeight: 400,
  },
  '1b': {
    fontSize: 1,
    letterSpacing: '-0.65px',
    lineHeight: '22px',
    fontWeight: 700,
  },
  '1r': {
    fontSize: 1,
    letterSpacing: '-0.6px',
    lineHeight: '22px',
    fontWeight: 400,
  },
  '-1r': {
    fontSize: -1,
    letterSpacing: '-0.45px',
    lineHeight: '18px',
    fontWeight: 400,
  },
  '-1b': {
    fontSize: -1,
    letterSpacing: '-0.4px',
    lineHeight: '18px',
    fontWeight: 700,
  },
  '-2r': {
    fontSize: -2,
    letterSpacing: '-0.4px',
    lineHeight: '16px',
    fontWeight: 400,
  },
  '-2u': {
    fontSize: -2,
    letterSpacing: '0.2px',
    lineHeight: '18px',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
};

const Text = styled('span', { shouldForwardProp })(
  color,
  variant({
    variants: Object.entries(styles).reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {}),
  }),
);

Text.propTypes = {
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(variants),
    PropTypes.arrayOf(PropTypes.oneOf(variants)),
  ]),
};

Text.defaultProps = {
  variant: '1r',
};

Text.displayName = 'Monterey(Text)';

export default Text;
